import api from "api/api"

export const GET_SALE_ITEMS_LOCATIONS = '[SALE_ITEMS_LOCATIONS] GET_SALE_ITEMS_LOCATIONS'
export const GET_SALE_ITEMS_LOCATIONS_LOADING = '[SALE_ITEMS_LOCATIONS] GET_SALE_ITEMS_LOCATIONS_LOADING'

export function getSaleItemsLocations(saleId, storeId = null) {
  return async (dispatch) => {
    dispatch({
      type: GET_SALE_ITEMS_LOCATIONS_LOADING,
      payload: true
    })

    try {
      const query = storeId ? `?storeId=${storeId}` : ''
      const response = await api.get(`/sale-items-locations/${saleId}${query}`)
      dispatch({
        type: GET_SALE_ITEMS_LOCATIONS,
        payload: response.data.data
      })
    } catch (error) {
      console.error(GET_SALE_ITEMS_LOCATIONS, error)
    } finally {
      dispatch({
        type: GET_SALE_ITEMS_LOCATIONS_LOADING,
        payload: false
      })
    }
  }
}
